import { FC } from 'react'

const ChatIcon: FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.12291 13.9122L3.125 13.9125L3.1261 13.9144L4.6462 13.1544L5.15236 13.3394C5.89066 13.6093 6.6834 13.75 7.5 13.75C7.95871 13.75 8.41027 13.7056 8.84964 13.6185L9.09269 14.8447C8.57939 14.9464 8.04652 15 7.5 15C6.51901 15 5.58201 14.8274 4.72319 14.5134L1.25 16.25L2.0907 12.8872C0.795891 11.6517 0 9.97355 0 8.125C0 4.32804 3.35786 1.25 7.5 1.25C11.2419 1.25 14.3438 3.76194 14.9083 7.04661L13.6763 7.25833C13.2119 4.55586 10.6113 2.5 7.5 2.5C4.02511 2.5 1.25 5.04385 1.25 8.125C1.25 9.57513 1.8625 10.9417 2.95363 11.9829L3.47975 12.4849L3.12291 13.9122Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6947 17.2224L18.75 18.75L18.0515 15.9559C19.2516 14.9309 20 13.4816 20 11.875C20 8.7684 17.2018 6.25 13.75 6.25C10.2982 6.25 7.5 8.7684 7.5 11.875C7.5 14.9816 10.2982 17.5 13.75 17.5C14.429 17.5 15.0827 17.4026 15.6947 17.2224ZM17.2397 15.0054L16.6511 15.5081L16.8782 16.4165L15.8137 15.8843L15.3417 16.0232C14.8339 16.1727 14.2987 16.25 13.75 16.25C10.9609 16.25 8.75 14.2602 8.75 11.875C8.75 9.48984 10.9609 7.5 13.75 7.5C16.5391 7.5 18.75 9.48984 18.75 11.875C18.75 13.0629 18.2046 14.1813 17.2397 15.0054Z"
      fill="white"
    />
  </svg>
)

export default ChatIcon
